import { InfoIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { IrrigationDeviceBase } from "verdi-web-client/Models/Devices/IrrigationDeviceBase";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { NAMESPACES } from "@/i18n/constants";

export function ManualModeWarning({ manualDevices }: { manualDevices: IrrigationDeviceBase[] }) {
    const { t } = useTranslation(NAMESPACES.FEATURES.CARDS, {
        keyPrefix: "zone.on-demand-irrigation.manual-mode-warning",
    });

    return (
        <Alert variant={"info"} size={"card"}>
            <InfoIcon />
            <AlertDescription className={"text-card-foreground gap-2"}>
                <p>{t("banner-description")}</p>
                <ul className={"list-disc list-inside font-medium"}>
                    {manualDevices.map((device) => (
                        <li key={device.id}>{device.name}</li>
                    ))}
                </ul>
            </AlertDescription>
        </Alert>
    );
}
